import React from "react";
import TextFieldInput from "../../../components/TextFieldInput";
import { useTranslation } from "react-i18next";
import GoogleMapsAutocomplete from "../../../shared-components/google-maps-autocomplete/GoogleMapsAutocomplete";
import { Grid } from "@mui/material";

const AddressFields = ({ addressType, formik, handlePlaceChanged }) => {
  const { t } = useTranslation("common");

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <GoogleMapsAutocomplete
          name={`${addressType}.areaName`}
          formik={formik}
          label={t("addressFields.labels.areaName")}
          required={true}
          placeholder={t("addressFields.placeholders.areaName")}
          variant="outlined"
          TextFieldProps={{ size: "small" }}
          onSelect={(data) => handlePlaceChanged(data)}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <TextFieldInput
          field={{
            name: `${addressType}.houseNumber`,
            label: t("addressFields.labels.houseNumber"),
            required: true,
            readonly: false,
            placeholder: t("addressFields.placeholders.houseNumber"),
            maxLength: 20,
            value: formik?.values?.[addressType]?.houseNumber,
          }}
          formik={formik}
          error={
            formik.touched[addressType]?.houseNumber &&
            Boolean(formik.errors[addressType]?.houseNumber)
          }
          helperText={
            formik.touched[addressType]?.houseNumber &&
            formik.errors[addressType]?.houseNumber
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <TextFieldInput
          field={{
            name: `${addressType}.city`,
            label: t("addressFields.labels.city"),
            required: true,
            readonly: false,
            placeholder: t("addressFields.placeholders.city"),
            maxLength: 50,
            value: formik?.values?.[addressType]?.city,
          }}
          formik={formik}
          error={
            formik.touched[addressType]?.city &&
            Boolean(formik.errors[addressType]?.city)
          }
          helperText={
            formik.touched[addressType]?.city &&
            formik.errors[addressType]?.city
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <TextFieldInput
          field={{
            name: `${addressType}.state`,
            label: t("addressFields.labels.state"),
            required:
              formik?.values?.[addressType]?.country === "" ||
              formik?.values?.[addressType]?.country === "India",
            readonly: false,
            placeholder: t("addressFields.placeholders.state"),
            maxLength: 50,
            value: formik?.values?.[addressType]?.state,
          }}
          formik={formik}
          error={
            formik.touched[addressType]?.state &&
            Boolean(formik.errors[addressType]?.state)
          }
          helperText={
            formik.touched[addressType]?.state &&
            formik.errors[addressType]?.state
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <TextFieldInput
          field={{
            name: `${addressType}.country`,
            label: t("addressFields.labels.country"),
            required: true,
            readonly: false,
            placeholder: t("addressFields.placeholders.country"),
            maxLength: 50,
            value: formik?.values?.[addressType]?.country,
          }}
          formik={formik}
          error={
            formik.touched[addressType]?.country &&
            Boolean(formik.errors[addressType]?.country)
          }
          helperText={
            formik.touched[addressType]?.country &&
            formik.errors[addressType]?.country
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
        <TextFieldInput
          field={{
            name: `${addressType}.pinCode`,
            label: t("addressFields.labels.pincode"),
            required:
              formik?.values?.[addressType]?.country === "" ||
              formik?.values?.[addressType]?.country === "India",
            readonly: false,
            placeholder: t("addressFields.placeholders.pincode"),
            maxLength: 6,
            value: formik?.values?.[addressType]?.pinCode,
          }}
          error={
            formik.touched[addressType]?.pinCode &&
            Boolean(formik.errors[addressType]?.pinCode)
          }
          helperText={
            formik.touched[addressType]?.pinCode &&
            formik.errors[addressType]?.pinCode
          }
          formik={formik}
        />
      </Grid>
    </>
  );
};

export default AddressFields;
